// src/services/CardDisplayService.js

export const uploadedImageNames = [
  "day1.png",
  "day10.png",
  "day11.png",
  "day12.png",
  "day13.png",
  "day14.png",
  "day15-1.png",
  "day15.png",
  "day16.png",
  "day17.png",
  "day19.png",
  "day20.png",
  "day21.png",
  "day24.png",
  "day26.png",
  "day27.png",
  "day28.png",
  "day29-1.png",
  "day29.png",
  "day3.png",
  "day30.png",
  "day31.png",
  "day32.png",
  "day35.png",
  "day4.png",
  "day40.png",
  "day41.png",
  "day42.png",
  "day43.png",
  "day45.png",
  "day46.png",
  "day47.png",
  "day48.png",
  "day5.png",
  "day50.png",
  "day51.png",
  "day53.png",
  "day54.png",
  "day6.png",
  "day60.png",
  "day63.png",
  "day66.png",
  "day67-1.png",
  "day67.png",
  "day7.png",
  "day70.png",
  "day74.png",
  "day75.png",
  "day76.png",
  "day83.png",
  "day85.png",
  "day86.png",
  "day87.png",
  "day88.png",
  "day89.png",
  "day9.png",
  "day91.png",
  "day92.png",
  "day93.png",
  "day94.png",
  "day95.png",
  "day96.png",
  "premium1.png"
];

// Lists for generating random card names
export const descriptors = [
  "Ancient",
  "Mystic",
  "Glorious",
  "Shadow",
  "Eternal",
  "Forsaken",
  "Cursed",
  "Savage",
  "Celestial",
  "Fallen",
  "Radiant",
  "Dreadful",
  "Vengeful",
  "Malevolent",
  "Piercing",
  "Cryptic",
  "Haunting",
  "Enigmatic",
  "Unholy",
  "Primeval",
];

export const nouns = [
  "Ghost",
  "Abomination",
  "Goblin",
  "Troll",
  "Orc",
  "Elf",
  "Dwarf",
  "Gnome",
  "Fairy",
  "Sprite",
  "Demon",
  "Angel",
  "Wraith",
  "Skeleton",
  "Zombie",
  "Vampire",
  "Werewolf",
  "Lycanthrope",
  "Hydra",
  "Basilisk",
  "Chimera",
  "Griffin",
  "Unicorn",
  "Kraken",
  "Leviathan",
  "Elemental",
  "Imp",
  "Djinn",
  "Nymph",
  "Dryad",
  "Sphinx",
  "Golem",
  "Minotaur",
  "Centaur",
  "Harpy",
  "Siren",
  "Banshee",
  "Hobgoblin",
  "Kobold",
  "Ogre",
  "Giant",
  "Titan",
  "Pegasus",
  "Serpent",
  "Manticore",
  "Wyvern",
  "Drake",
  "Ent",
  "Phantasm",
  "Revenant",
  "Specter",
  "Shade",
  "Poltergeist",
  "Lich",
  "Succubus",
  "Incubus",
  "Trollkin",
  "Bogle",
  "Wight",
  "Wisp",
  "Chupacabra",
  "Wendigo",
  "Yeti",
  "Bigfoot",
  "Gargoyle",
  "Mummy",
  "Efreet",
  "Roc",
  "Rusalka",
  "Kelpie",
  "Drider",
  "Ettin",
  "Ghoul",
  "Jackalope",
  "Kitsune",
  "Kappa",
  "Oni",
  "Rakshasa",
  "Tengu",
  "Thunderbird",
  "Valkyrie",
  "Ghast",
  "Reaper",
  "Changeling",
  "Doppelganger",
  "Brownie",
  "Ymir",
  "Fenrir",
  "Naga",
  "Sahuagin",
  "Merfolk",
  "Undine",
  "Satyr",
  "Treant",
  "Cyclops",
  "Gorgon",
  "Voidspawn",
  "Behemoth",
];


/**
 * Returns a random image filename from the uploadedImageNames list.
 */
export function getRandomImageName() {
  const idx = Math.floor(Math.random() * uploadedImageNames.length);
  return uploadedImageNames[idx];
}

/**
 * Returns a random card name composed of a descriptor and a noun.
 */
export function getRandomCardName() {
  const descriptor = descriptors[
    Math.floor(Math.random() * descriptors.length)
  ];
  const noun = nouns[
    Math.floor(Math.random() * nouns.length)
  ];
  return `${descriptor} ${noun}`;
}
